import React, { useEffect, useState } from 'react';
import { activateAccount } from '../api';

function Activate({ onGoToLogin }) {
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Activating your account...');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token') || '';

    if (!token) {
      setStatus('error');
      setMessage('This activation link is missing a token.');
      return;
    }

    activateAccount(token)
      .then((result) => {
        setStatus('success');
        setMessage(result.message || 'Your account is active. You can sign in.');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.error || 'Unable to activate this account.');
      });
  }, []);

  return (
    <div className="container">
      <p className="brand">My Weed Buddy</p>
      <h1>Activate account</h1>
      {status === 'error' ? (
        <div className="error">{message}</div>
      ) : status === 'success' ? (
        <div className="success">{message}</div>
      ) : (
        <p className="subtitle">{message}</p>
      )}
      <button type="button" onClick={onGoToLogin}>
        Go to sign in
      </button>
    </div>
  );
}

export default Activate;
